// Dependencies
import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

// Components
import Seo from '../components/seo/seo';
import Layout from '../components/layout/layout';
import FlexibleContentFactory from '../components/flexibleContent/flexibleContentFactory/flexibleContentFactory';

export default function PageTemplate({ data: { page }, location }) {
  const title = page?.title;
  const pageDisplayOptions = page?.pageDisplayOptions;
  const isFrontPage = page?.isFrontPage;

  const yoast = page?.seo;

  const stage = page?.microsoftClarity?.stage;

  return (
    <Layout
      isFrontPage={isFrontPage}
      pageDisplayOptions={pageDisplayOptions}
      title={title}
      userJourneyStage={stage}
    >
      <Seo yoast={yoast} locationData={location} />
      <FlexibleContentFactory
        layouts={page?.flexibleContent?.layouts}
        pageDisplayOptions={pageDisplayOptions}
        isFrontPage={isFrontPage}
      />
    </Layout>
  );
}

export const pageQuery = graphql`
  query PageById($id: String!) {
    page: wpPage(id: { eq: $id }) {
      id
      title
      isFrontPage
      pageDisplayOptions {
        topSpacing
        displayTitle
        titleAlignment
      }
      seo {
        ...seoFields
      }
      flexibleContent {
        layouts: flexibleContent {
          ...flexibleContentFields
        }
      }
      microsoftClarity {
        stage
      }
    }
  }
`;

PageTemplate.propTypes = {
  location: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    page: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      seo: PropTypes.shape({}),
      flexibleContent: PropTypes.shape({
        layouts: PropTypes.arrayOf(PropTypes.shape({})),
      }),
      isFrontPage: PropTypes.bool.isRequired,
      pageDisplayOptions: PropTypes.shape({
        topSpacing: PropTypes.bool,
      }).isRequired,
      microsoftClarity: PropTypes.shape({
        stage: PropTypes.string,
      }),
    }).isRequired,
  }).isRequired,
};
